export const deClientPortalHandoverApprovalStatusActions = {
    handover: {
        chipLabel: 'Anmerkungen geteilt',
        sharedByTooltip: 'geteilt von {{user}}',
        sharedOn: 'Geteilt am {{date}}',
        shared: 'geteilt',
        actionDescription: 'Anmerkungen an Gutachter/in übermitteln und neuen Entwurf anfordern.',
    },
    approval: {
        approvedOn: 'freigegeben am {{date}}',
        approved: 'freigegeben',
        openApprovalDescription: 'Freigabe des Entwurfs erteilen und Finalisierung anfordern.',
    },
}
